// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconFooterEnvelope = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
            <path
                fill="currentColor"
                d="M0,0 L20,0 L20,3.125 L10,10 L0,3.125 L0,0 Z M0,15 L0,4.64062452 L9.29296851,11.0312498 L10,11.5156245 L10.7070315,11.0273433 L20,4.64062452 L20,15 L0,15 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(IconFooterEnvelope);
